import { Link } from 'react-router-dom'

import Title from '../components/items/Title'
import LinkButton from '../components/items/LinkButton'
import Technology from '../components/items/Technology'

import react from '../img/technology/react.png'
import css from '../img/technology/css.png'
import html from '../img/technology/html.png'
import javaScript from '../img/technology/javascript.png'

import styles from './projects.module.css'

export default function Projects() {
  return (
    <section id="Projects" className={styles.containerProjects}>
      <Title title="MEU" subTitle="PORTFÓLIO." />
      <div className={styles.projects}>
        <Link to="/project7" className={styles.project7}>
          <div className={styles.overlay}>Rater</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={javaScript} name="JavaScript" />
          </div>
        </Link>
        <Link to="/project6" className={styles.project6}>
          <div className={styles.overlay}>expertNotes</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={javaScript} name="JavaScript" />
          </div>
        </Link>
        <Link to="/project9" className={styles.project9}>
          <div className={styles.overlay}>bakery</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={javaScript} name="JavaScript" />
          </div>
        </Link>
      </div>
      <div className={styles.otherProjects}>
        <Link to="/otherProjects">
          <LinkButton text="Mais Projetos..." />
        </Link>
      </div>
    </section>
  )
}
